import F84Game from "../Game";
import ResizableScene from "./ResizableScene";

export default class RotateDevice extends ResizableScene {
	private _bg: Phaser.GameObjects.Graphics;
	private _rotateImg: Phaser.GameObjects.Image;

	create(): void {
		const graphics: Phaser.GameObjects.Graphics = this.add.graphics({ x: 0, y: 0 });
		graphics.setInteractive();
		graphics.fillStyle(0x000000, 1);
		graphics.fillRect(0, 0, this.game.scale.width, this.game.scale.height);
		this._bg = graphics;

		this._rotateImg = this.add.image(0, 0, "rotateDevice", null);
		this._rotateImg.setInteractive();
	}

	update(time: number, delta: number): void {
		super.update(time, delta);

		this.game.scene.bringToTop(this);

		const scale =
			this.game.scale.width > this.game.scale.height
				? this._viewport.height / this._rotateImg.height
				: this._rotateImg.height / this._viewport.height;
		this._rotateImg.setScale(scale);

		this._bg.fillStyle(0x000000, 1);
		this._bg.fillRect(0, 0, this.game.scale.width, this.game.scale.height);
		Phaser.Display.Align.In.Center(this._rotateImg, this._viewport);

		const sign = Math.sign(this.game.scale.width - this.game.scale.height);
		const sign2 = Math.sign(F84Game.Instance.DefaultWidth - F84Game.Instance.DefaultHeight);

		if (sign == sign2) {
			this.scene.stop("RotateDevice");
		}
	}
}
